import CountingMethod from './../utils/getCountingMethod'
export default function maskSmallCount (value) {
    if(value<5)
    return '<5'
    else
    return CountingMethod(value,'fixed')
}
